import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref, shallowRef } from 'vue'

import { bookingsApi } from '@/api/client'
import type { GetLocations200ResponseInner } from '@/openapi'

export type LocationInfo = {
  locationId: string
  schedules: Record<
    string,
    {
      id: string
      locationId: string
      day: string
      start: string
      end: string
    }[]
  >
  brandInfo: {
    id: string
    locationId: string
    brandId: string
    enabled: boolean
    name: string
    coverImageId: string
    colorLogoImageId: string
    faviconImageId: string | null
    accentColor: string
    secondaryColor: string | null
    topbarColor: string | null
    backgroundImageId: string | null
    backgroundColor: string | null
    squareLogo: string | null
    position: number
  }
  timezone: string
  locationAddress: string
  locationPhoneNumber: string
  language: string
  zones: {
    zone: string
  }[]
  maxSeats: {
    terraza: number
    sala: number
  }
  scripts: any
}

export const useAuthStore = defineStore('auth', () => {
  const organizationId = ref<string | null>(null)
  const locationId = ref<string | null>(null)

  const organizationLocations = shallowRef<GetLocations200ResponseInner[] | null>(null)

  function setLocationId(id: string) {
    locationId.value = id
  }

  function setOrganizationId(id: string) {
    organizationId.value = id
  }

  async function getOrganizationLocations() {
    if (!organizationId.value) return
    organizationLocations.value = await bookingsApi.getLocations()
  }

  return {
    locationId,
    organizationId,
    organizationLocations,
    setLocationId,
    setOrganizationId,
    getOrganizationLocations
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot))
}
